// Mock data for Oaklawn Enterprise website

export const services = [
  {
    id: 1,
    title: "Drop Shipping Mastery",
    description: "Learn proven strategies from 20+ years of drop shipping experience. Master product selection, supplier relationships, and scaling techniques.",
    image: "https://images.unsplash.com/photo-1449247666642-264389f5f5b1",
    features: ["Product Research", "Supplier Network", "Marketing Strategy", "Scaling Systems"]
  },
  {
    id: 2,
    title: "Amazon FBA Consulting",
    description: "Navigate Amazon FBA with expert guidance. From product sourcing to listing optimization and inventory management.",
    image: "https://images.pexels.com/photos/16158536/pexels-photo-16158536.jpeg",
    features: ["Product Sourcing", "Listing Optimization", "PPC Campaigns", "Inventory Management"]
  }
];

export const benefits = [
  {
    id: 1,
    icon: "Award",
    title: "20+ Years Experience",
    description: "Two decades of proven success in the drop shipping and e-commerce industry"
  },
  {
    id: 2,
    icon: "TrendingUp",
    title: "Proven Track Record",
    description: "Helped countless entrepreneurs build successful online businesses from scratch"
  },
  {
    id: 3,
    icon: "Users",
    title: "Personalized Guidance",
    description: "One-on-one consultation tailored to your specific business goals and challenges"
  },
  {
    id: 4,
    icon: "Target",
    title: "Results-Driven Approach",
    description: "Focus on actionable strategies that deliver measurable business growth"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Johnson",
    role: "E-commerce Entrepreneur",
    content: "The consultation completely transformed my drop shipping business. Within 3 months, I went from struggling to make sales to consistent $10K months. The expertise is unmatched!",
    rating: 5
  },
  {
    id: 2,
    name: "Michael Chen",
    role: "Amazon FBA Seller",
    content: "Best investment I've made in my business. The FBA strategies and supplier connections have been game-changing. Highly recommend to anyone serious about e-commerce.",
    rating: 5
  },
  {
    id: 3,
    name: "David Martinez",
    role: "Online Retailer",
    content: "Started as a complete beginner and now running a successful 6-figure drop shipping store. The step-by-step guidance and ongoing support made all the difference.",
    rating: 5
  }
];

export const stats = [
  { value: "20+", label: "Years Experience" },
  { value: "500+", label: "Clients Helped" },
  { value: "$50M+", label: "Revenue Generated" },
  { value: "95%", label: "Success Rate" }
];
